import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUnblock: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconUnblock"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 13.8484 4.62892 15.5488 5.68164 16.9033L9.29297 13.293L10.707 14.707L7.0957 18.3174C8.45045 19.3706 10.1511 20 12 20C16.4183 20 20 16.4183 20 12C20 10.1511 19.3706 8.45045 18.3174 7.0957L14.707 10.707L13.293 9.29297L16.9033 5.68164C15.5488 4.62892 13.8484 4 12 4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconUnblock;
